import angular from 'angular';

// Use Vite's import.meta.glob instead of bulk-require
const modules = import.meta.glob(['./**/*.js', '!./index.js', '!./**/*.spec.js'], { eager: true });

const filtersModule = angular.module('app.filters', []);

function declare(mod) {
  if (!mod) return;
  
  const item = mod.default || mod;
  
  if (item.fn && typeof item.fn === 'function') {
    filtersModule.filter(item.name, item.fn);
  }
}

Object.values(modules).forEach(declare);

export default filtersModule;
